module.exports = __webpack_public_path__ + "img/9.783bf36d.png";